import { combineReducers } from 'redux';

import { competitionParametersFeedbackReducer } from './competition-parameters-feedback/reducer';
import { feedbackReducer } from './feedback/reducer';
import type { MissedDealFeedbackState } from './model';

export const missedDealFeedbackReducer = combineReducers<MissedDealFeedbackState>({
  feedback: feedbackReducer,
  competitionParametersFeedback: competitionParametersFeedbackReducer,
});
